import { CustomField } from "@/types";
import { http } from "@/utils/http-common";

export async function getCustomFields(): Promise<CustomField[]> {
  return http.get("/customFields").then((response) => response.data.data);
}

export async function editCustomField(customField: CustomField) {
  return http.put(`/customFields/${customField.id}`, { ...customField, defaultValue: customField.defaultValue ?? null }).then((response) => response.data.data);
}

export async function createCustomField(customField: CustomField) {
  return http.post("/customFields", customField).then((response) => response.data.data);
}

export async function deleteCustomField(id: number) {
  return http.delete(`/customFields/${id}`).then((response) => response.data.data);
}
